import React from "react"
import { FormattedMessage, FormattedNumber } from "react-intl"
import { StockDocumentCostListingLabelProps } from "../../common/types/inventory"
import { PRODUCT_TYPE } from "../../state/product/Types"
import { getCostByInventoryLocation } from "../../state/product/Utils"
import { SupplierCostElastic } from "../../state/product/models"
import { INVENTORY_STOCK_DIRECTION } from "../../utils/inventory"

const CostListingLabel= (props: StockDocumentCostListingLabelProps) => {
    if(!props.stockDocument && !props.item){
        return ""
    }

    const renderCost = () => {
        if (props.item && props.stockDocument?.definition) {
            if (props.item.type == PRODUCT_TYPE.MATRIX_PARENT) {
                return  <FormattedMessage
                    id="add_item_modal.products.list.price_matrix_cost_from_label"
                    defaultMessage="from {price}"
                    values={{
                        "price": <FormattedNumber
                            style="currency"
                            currency={props.item.currency}
                            value={props.item.oneTimeMinimumCost || ""}
                        />
                    }}
                />
            }

            if (props.stockDocument.definition.attributes.direction === INVENTORY_STOCK_DIRECTION.IN) {
                const supplierId = props.stockDocument.project.attributes.contactId
                let unitCost = props.item.defaultUnitCost
                const costs = props.item.supplierCosts as Array<SupplierCostElastic>
                const supplierCost =  costs?.find(cost => cost.supplierId === supplierId)
                if (supplierCost && supplierCost.unitCost) {
                    unitCost = supplierCost.unitCost
                }
                return (<FormattedNumber
                    style="currency"
                    currency={props.item.currency}
                    value={unitCost}
                />)
            } else {
                return (
                    <FormattedNumber
                        style="currency"
                        currency={props.item.currency}
                        value={getCostByInventoryLocation(props.item,props.stockDocument.inventoryLocationId)}
                    />)
            }
        }
        
    }
    return (
        <p className={`m-0 ${props.className}`}>
            {renderCost()}
        </p>
    )

}

export default CostListingLabel


// WEBPACK FOOTER //
// ./src/product/components/StockDocumentCostListingLabel.tsx